module.exports = __webpack_public_path__ + "static/texturascomplementarias-86d4ee1402d2478be721cdbfa2c15e07.pdf";